module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Half-star-31a54b9eb0c406c0b61b0f5dd16fe82f.svg";